import api from "./base-api"

const mcPlayerEventApiV1 = api.injectEndpoints({
    endpoints: (build) => ({
        getPlayerEventsV1Mc: build.query({
            query: ({
                userId = "",
                from,
                to
            }) => `v1/mc/player-events/${userId}?from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}`,
            keepUnusedDataFor: 300
        })
    }),
    overrideExisting: false
})

export const {
    useGetPlayerEventsV1McQuery
} = mcPlayerEventApiV1
